export class SCACancelledError extends Error {
  constructor(message = 'SCA cancelled by user') {
    super(message)
    this.name = 'SCACancelledError'
  }
}

export function isSCACancelledError(error: unknown): boolean {
  return error instanceof SCACancelledError
}
